<template lang="html">

  <section class="app-footer">
    <footer class="footer">
      <div class="container-fluid clearfix">
        <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">Copyright © 2020. All rights reserved.</span>
        <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Designed & Maintained by <a href="http://www.leopardtechlabs.com/" target="_blank">Leopard Tech Labs</a></span>
      </div>
    </footer>
  </section>

</template>

<script lang="js">
export default {
  name: 'app-footer'
}
</script>

<style scoped lang="scss">
.app-footer {

}
</style>



// WEBPACK FOOTER //
// src/components/partials/AppFooter.vue